window.RegisterView = function () {
	const _self       = this,
		  _components = {
			  $autocompleteField: $('.js-address-autocomplete'),
			  $streetField: $('.js-address-street'),
			  $zipcodeField: $('.js-address-zipcode'),
			  $cityField: $('.js-address-city'),
			  $countryField: $('.js-address-country'),
			  $latField: $('.js-address-lat'),
			  $lngField: $('.js-address-lng'),
			  $noChooseError: $('.js-address-no-choose-error'),
			  $firmAccountCbx: $('.js-firm-account-checkbox'),
			  $classicUserFieldsDiv: $('.js-classic-user-fields'),
			  $firmFieldsDiv: $('.js-firm-fields'),
		  };
	let _autocomplete, _geocoder;

	/**
	 * init function
	 *
	 * @private
	 */
	function _init () {
		window.initAccountViewServices = _initGoogleServices;
		console.log('test')
		_onChangeFirmAccount();
		_onBlurAddressField();
	}

	/**
	 * Init Google Maps Autocomplete
	 *
	 * @private
	 */
	function _initGoogleServices () {
		// === Autocomplete ===
		_autocomplete = new google.maps.places.Autocomplete(_components.$autocompleteField[0], {
			types: ['address'],
			componentRestrictions: { country: ["fr", "gp", "mq", "gf", "re", "pm", "yt", "nc", "pf", "mf", "tf"] },
		});
		_autocomplete.setFields(['address_component']);
		_autocomplete.addListener('place_changed', _geocodeAddress);

		// === Geocoder ===
		_geocoder = new google.maps.Geocoder();
	}

	/**
	 * Geocoder une adresse depuis Google Maps Geocoder
	 *
	 * @private
	 */
	function _geocodeAddress () {
		const place    = _autocomplete.getPlace(),
			  location = place.address_components.map(a => a.long_name).join(' ');

		_geocoder.geocode({ 'address': location }, function (results, status) {
			if (status === 'OK') {
				const result = results[0],
					  str    = result.formatted_address,
					  lat    = result.geometry.location.lat(),
					  lng    = result.geometry.location.lng();

				let streetNumber = '',
					route        = '',
					zipCode      = '',
					city         = '',
					country      = '';

				result.address_components.forEach(function (element) {
					switch (element.types[0]) {
						case 'street_number' :
							streetNumber = element.long_name;
							break;
						case 'route' :
							route = element.long_name;
							break;
						case 'postal_code' :
							zipCode = element.long_name;
							break;
						case 'locality' :
							city = element.long_name;
							break;
						case 'country' :
							country = element.long_name;
							break;
					}
				})

				_components.$autocompleteField.attr('value', str);
				_components.$streetField.attr('value', [streetNumber, route].join(' '));
				_components.$zipcodeField.attr('value', zipCode);
				_components.$cityField.attr('value', city);
				_components.$countryField.attr('value', country);
				_components.$latField.attr('value', lat);
				_components.$lngField.attr('value', lng);

				_components.$autocompleteField.removeClass('is-invalid');
			} else {
				_components.$autocompleteField.val('');
				toastr.error("Nous n'avons pas pu récupérer l'adresse de la ville saisie. Si l'erreur persiste, contactez-nous.");
				console.error('Geocode was not successful for the following reason: ' + status);
			}
		});
	}

	/**
	 * Informer le user qu'il doit sélectionner une adresse proposée par Google
	 *
	 * @private
	 */
	function _onBlurAddressField () {
		_components.$autocompleteField.on('blur', function () {
			if (_components.$autocompleteField.val() !== '' && (_components.$latField.val() === '' || _components.$lngField.val() === '')) {
				_components.$autocompleteField.addClass('is-invalid');
				return false;
			} else {
				_components.$autocompleteField.removeClass('is-invalid');
				return true;
			}
		});
	}

	/**
	 * Afficher des champs de formulaire différentes en fonction du type de compte
	 *
	 * @private
	 */
	function _onChangeFirmAccount () {
		_components.$firmAccountCbx.on('change', function () {
			if ($(this).is(':checked')) {
				// _components.$classicUserFieldsDiv.addClass('d-none');
				_components.$firmFieldsDiv.removeClass('d-none');
				$('#firm-name').prop("required", true);
				$("label[for='firm-name']").addClass('is-required')
				$('#moral').removeClass('d-none');
				$('#physical').addClass('d-none');
			} else {
				// _components.$classicUserFieldsDiv.removeClass('d-none');
				_components.$firmFieldsDiv.addClass('d-none');
				$('#firm-name').prop("required", false);
				$("label[for='firm-name']").removeClass('is-required')
				$('#moral').addClass('d-none');
				$('#physical').removeClass('d-none');
			}
		});
	}

	_init();
};
